import React from 'react';
import { Button } from 'antd';
import { CloseOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { WAREHOUSE_ROUTES } from 'constants/routes';
import ScribexERPLogo from '../../../../assets/icons/scribex-erp-logo.svg';
import { SideBarLogoCollapsedIcon } from '../../../common/icons/SideBarLogoCollapsedIcon';

interface SidebarHeaderProps {
  isMobile: boolean;
  isCollapsed: boolean;
  onMobileClose: () => void;
}

export const SidebarHeader: React.FC<SidebarHeaderProps> = ({isMobile, isCollapsed, onMobileClose}) => {
  const navigate = useNavigate();

  const handleLogoClick = () => {
    navigate(WAREHOUSE_ROUTES.inboundPackages);
  };

  return (
    <div className="warehouse-sidebar-header">
      {isMobile ? (
        <div className="mobile-sidebar-header">
          <img
            src={ScribexERPLogo}
            alt="Scribex ERP Logo"
            className="sidebar-logo"
            onClick={handleLogoClick}
            style={{cursor: 'pointer'}}
          />
          <Button type="text" icon={<CloseOutlined/>} onClick={onMobileClose} className="mobile-close-button"/>
        </div>
      ) : (
        <div className="logo" onClick={handleLogoClick} style={{cursor: 'pointer'}}>
          {isCollapsed ? <SideBarLogoCollapsedIcon/> :
            <img src={ScribexERPLogo} alt="Scribex ERP Logo" className="desktop-logo"/>}
        </div>
      )}
    </div>
  );
};
